import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

const SKIP_LOADING_PATTERNS: RegExp[] = [
  /\/health(check)?(\/|\?|$)/i,
  /\/telemetry(\/|\?|$)/i,
  /\/metrics(\/|\?|$)/i,
  /\/ping(\/|\?|$)/i,
  /\/favicon\.ico(\?|$)/i,
  /\/assets\//i
];

function shouldSkipLoading(url: string): boolean {
  return SKIP_LOADING_PATTERNS.some((pattern) => pattern.test(url));
}

function isDashboardRoute(currentUrl: string): boolean {
  const normalized = (currentUrl || '').split('?')[0].split('#')[0];
  return normalized === '/dashboard' || normalized.startsWith('/dashboard/');
}

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  if (!isDashboardRoute(router.url)) {
    return next(req);
  }

  if (req.headers.has('x-skip-loading') || shouldSkipLoading(req.url)) {
    return next(req);
  }

  loadingService.adicionar();

  return next(req).pipe(
    finalize(() => loadingService.remover())
  );
};
